import { DEFAULT_TOTAL_RECORDS } from "utils/constants";

const { EndPoints } = require("settings/endpoints");
const { default: axiosInstance } = require("./axios");
const zone_id = Number(localStorage.getItem("zone_id"));

export const fetchTermsConditions = (page_no, filter, limit = DEFAULT_TOTAL_RECORDS) => {
  return axiosInstance.get(EndPoints.INVENTORY_TERMS_CONDITION.LIST, {
    params: {
      limit,
      page_no,
      zone_id,
      ...filter
      // total_count:totalItems
    }
  });
}

export const fetchTermsCondition = (payload) => {
  return axiosInstance.get(EndPoints.INVENTORY_TERMS_CONDITION.TERMS_CONDITION_LIST_BY_ID + `/${payload}`);
}

export const createTermsCondition = (payload) => {
  return axiosInstance.post(EndPoints.INVENTORY_TERMS_CONDITION.CREATE, payload)
}

export const updateTermsCondition = (payload) => {
  return axiosInstance.put(EndPoints.INVENTORY_TERMS_CONDITION.UPDATE, payload)
}


export const deleteTermsCondition = (payload) => {
  const url = EndPoints.INVENTORY_TERMS_CONDITION.DELETE + `/${payload}`
  return axiosInstance.delete(url)
}

export const downloadCSV = () => {
  return axiosInstance.put(EndPoints.INVENTORY_TERMS_CONDITION.DOWNLOAD_CSV, {
    responseType: 'blob'
  });
}
